<app-notification-bar [item]="notifications" *ngIf="notifications"></app-notification-bar>
<app-header></app-header>

<app-scroll
  *ngIf="showScroll$ | async"
  (scrollToTop)="onScrollToTop()"
></app-scroll>

<app-side-nav
    *ngIf="displayHeader()"
    [navListItems]="navListItems"></app-side-nav>
<router-outlet></router-outlet>

<div class="install-container" *ngIf="modalPwaPlatform === 'ANDROID'">
    <div class="install-btn" (click)="addToHomeScreen()">
        Install App
    </div>
</div>
